<div class="flex flex-col gap-4 items-center justify-center">
	<div class="flex gap-4 items-center">
		<div class="flex w-32 h-32">
			<img src="/assets/images/closer-logo.svg" />
		</div>
		<app-icon [icon]="ICON.OVERRIDE" class="text-xl text-grey-light"></app-icon>
		<div class="flex w-20 h-20">
			<img src="/assets/images/integrations/chicago-title-logo.svg" />
		</div>
	</div>
	<p class="text-xl font-bold text-center">
		Verify your firm name before connecting
	</p>
	<p class="text-center text-sm">
		To avoid creating a duplicate record, please verify that your firm name in
		Closer matches the entry within your CTIC Express account.
	</p>
	<div class="flex flex-col items-center justify-center my-4 gap-2">
		<div
			class="rounded-md border border-grey-lighter flex items-center justify-center p-2 gap-3"
			*ngIf="!editing"
		>
			<p>{{ lawFirmName }}</p>
			<app-icon
				[icon]="ICON.EDIT"
				(click)="toggleEdit()"
				class="cursor-pointer"
			></app-icon>
		</div>
		<div class="flex gap-2 items-center justify-end" *ngIf="editing">
			<app-input [(ngModel)]="lawFirmName"></app-input>
			<app-icon
				[icon]="ICON.CHECK"
				class="text-green cursor-pointer"
				(click)="toggleEdit()"
				label="Firm name"
			></app-icon>
		</div>
		<app-checkbox
			*ngIf="!editing"
			type="clear"
			[(ngModel)]="confirmFirmName"
			label="Is this the correct name?"
		></app-checkbox>
	</div>
	<div class="text-sm flex flex-col items-center justify-center">
		<app-anchor
			[icon]="ICON.EXTERNAL"
			[external]="true"
			url="https://express.ctic.ca/clients/default.aspx?LANG=en-CA"
			>Not sure? Check CTIC Express profile</app-anchor
		>
		<app-anchor
			[icon]="ICON.EXTERNAL"
			[external]="true"
			url="https://express.ctic.ca/clients/default.aspx?LANG=en-CA"
			>New to CTIC? Enroll now</app-anchor
		>
	</div>
</div>
<div class="flex gap-2 my-4 justify-between">
	<app-button btn="secondary" size="small" (click)="cancel()"
		>Cancel</app-button
	>
	<app-button
		btn="primary"
		size="small"
		(click)="connect()"
		[disabled]="!confirmFirmName"
		>Connect</app-button
	>
</div>
